"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _reactRedux = require("react-redux");
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _BrixelButtonPrimary = _interopRequireDefault(require("./BrixelButtonPrimary"));
var _BrixelButtonIcon = _interopRequireDefault(require("./BrixelButtonIcon"));
var _BrixelButtonSecondary = _interopRequireDefault(require("./BrixelButtonSecondary"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelNotification = props => {
  const {
    className = '',
    closeTime = 3000,
    form = {},
    fullWidth = false,
    handleSetNotification = () => '',
    icon = null,
    isSmallLoading = {},
    label = null,
    lang,
    notification = {},
    resetForm = () => '',
    translations,
    type = 'secondary'
  } = props;
  const color = () => {
    let colorData = {
      name: 'primary',
      bg: 'bgPrimary50',
      txt: 'txtPrimary400',
      rounded: true
    };
    switch (type) {
      case 'alert':
        colorData = {
          name: 'red',
          bg: 'bgRed50',
          txt: 'txtRed400'
        };
        break;
      case 'confirm':
        colorData = {
          name: 'blue',
          bg: 'bgBlue50',
          txt: 'txtBlue400'
        };
        break;
      case 'done':
        colorData = {
          name: 'green',
          bg: 'bgGreen50',
          txt: 'txtGreen400'
        };
        break;
      case 'save':
        colorData = {
          name: 'primary',
          bg: 'bgPrimary50',
          txt: 'txtPrimary400',
          rounded: true
        };
        break;
      case 'warning':
        colorData = {
          name: 'yellow',
          bg: 'bgYellow50',
          txt: 'txtYellow400'
        };
        break;
      default:
        colorData = {
          name: 'primary',
          bg: 'bgPrimary50',
          txt: 'txtPrimary400',
          rounded: true
        };
    }
    return colorData;
  };
  const defaultIcon = () => {
    if (!icon) {
      switch (type) {
        case 'alert':
          return 'close-circle';
        case 'confirm':
          return 'info';
        case 'done':
          return 'check-small';
        case 'save':
          return 'alarm';
        case 'warning':
          return 'alert';
        default:
          return '';
      }
    }
    return icon;
  };
  const defaultLabel = () => {
    if (!label) {
      switch (type) {
        case 'alert':
          return (0, _translation.default)('There is an error somewhere', lang, undefined, translations);
        case 'confirm':
          return (0, _translation.default)('You got served', lang, undefined, translations);
        case 'done':
          return (0, _translation.default)('You accomplished your goal', lang, undefined, translations);
        case 'save':
          return (0, _translation.default)('You have things unsaved', lang, undefined, translations);
        case 'warning':
          return (0, _translation.default)('You should be carefull with that', lang, undefined, translations);
        default:
          return '';
      }
    }
    return label;
  };
  const defaultFunc = act => {
    const not = (0, _cloneDeep.default)(notification) || {};
    const fullForm = (0, _cloneDeep.default)(form);
    switch (act) {
      case 'saveData':
        not.action = 'saveData';
        handleSetNotification(not);
        break;
      case 'discardChanges':
        Object.keys(fullForm).forEach(key => {
          resetForm(key, fullForm[key].initialValues);
        });
        break;
      case 'close':
        not.state = false;
        handleSetNotification(not);
        break;
      case 'reloadPage':
        window.location.reload();
        break;
      default:
        return '';
    }
    return null;
  };
  (0, _react.useEffect)(() => {
    if (type === 'done' || notification.autoHide) {
      const delayClose = notification.autoHide || closeTime;
      setTimeout(() => {
        defaultFunc('close');
      }, delayClose);
    }
  }, [type]);
  const buttons = () => {
    switch (type) {
      case 'alert':
      case 'done':
      case 'warning':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, notification.action === 'reloadButton' && (/*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
          bgTransparent: true,
          className: "mr-2",
          theme: "red",
          label: (0, _translation.default)('Reload page', lang, undefined, translations),
          onClick: () => defaultFunc('reloadPage')
        })), /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
          icon: "close",
          bgTransparent: true,
          theme: color().name,
          ghost: true,
          onClick: () => defaultFunc('close')
        }));
      case 'save':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
          className: "mr-2",
          rounded: true,
          theme: "primary",
          label: (0, _translation.default)('save', lang, undefined, translations),
          onClick: () => defaultFunc('saveData'),
          isLoading: isSmallLoading.saveData
        }), /*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
          rounded: true,
          bgTransparent: true,
          theme: "primary",
          label: (0, _translation.default)('Discard changes', lang, undefined, translations),
          onClick: () => defaultFunc('discardChanges')
        }));
      case 'confirm':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
          className: "mr-2",
          theme: "primary",
          label: (0, _translation.default)('Accept', lang, undefined, translations),
          onClick: () => defaultFunc('close')
        }), /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
          icon: "close",
          bgTransparent: true,
          theme: color().name,
          ghost: true,
          onClick: () => defaultFunc('close')
        }));
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-notification shadow-4dp ${className} ${color().bg} ${fullWidth ? 'fullWidth' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${fullWidth ? 'container' : ''} ${type === 'done' ? 'dis-fl-row' : 'dis-fl-col dis-fl-row-sm'} jc-c jc-b-sm`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-f a-c jc-sm-b ${type === 'done' ? 'mr-2' : 'mb-2 mb-sm-0 '}`
  }, (typeof icon !== 'boolean' || icon) && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "mr-2",
    color: color().name,
    saturationTxt: color().name === 'white' ? 0 : 400,
    icon: defaultIcon()
  })), (typeof label !== 'boolean' || label) && (/*#__PURE__*/_react.default.createElement("p", {
    className: `label ${color().txt} ${!fullWidth ? 'mr-0 mr-sm-4' : 'ml-2'}`
  }, (0, _translation.default)(defaultLabel(), lang, undefined, translations)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c jc-b"
  }, buttons())));
};
const mapStateToProps = state => ({
  form: (0, _get.default)(state, 'brixelForm', {}),
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelNotification);